export default {
  CART_NAME: '购物车',
  GO_CHECK_IT_OUT: '今日特惠逛一逛',
  SAVE_SHIPPING_FEE: {
    REPURCHASE: '再买',
    MEET_FREE_SHIPPING: '立享满',
    COMPLETE_FREE_SHIPPING: '元免运费',
    ALREADY_FREE_SHIPPING: '已享满',
    SHORT_FREE_SHIPPING: '免运费'
  },
  CART_COUNTDOWN_TIME_FORMAT: 'DD天HH:mm:ss',
  ADD_ITEM_FOR_FREE_SHIPPING: '凑单免邮费',
  STROLL_AROUND_AGAIN: '挑宝贝, 再逛逛',
  VIEW_DETAILS: '查看明细',
  PACK_UP: '收起',
  PROMOTIONAL_DEDUCTION: '促销减',
  TOTAL_DE_DUCTION: '共减',
  NEW_CUSTOMERS_COUPON_REACH: '新人券满',
  DEDUCTION: '减',
  SHIPPING_FEE_SAVING: '运费省',
  REACH: '满',
  FREE_SHIPPING: '免运费',
  TOTAL_SAVINGS_ON_SHIPPING: '共节省运费',
  ADD_ITEMS_FOR_FREE_SHIPPING: '凑单免运费',
  REC_PRODUCTS_UPDATED_HOURLY: '推荐商品每小时更新',
  EXCLUDE_SHIPPING_TAX: '(不含运费及进口费用)',
  TOTAL_AMOUNT: '商品合计',
  RETURN_TO_CART: '返回购物车',
  ALL: '全部',
  DOTD_OR_SPECIAL_SALE_EVENT: '镇店之宝/特卖汇',
  REDUCE_THE_PRICE: '降价',
  ALREADY_SOLD_OUT: '已抢光',
  OUT_OF_STOCK_AT_PRESENT: '目前没货',
  THE_PRODUCT_WERE_SOLD_OUT: '商品被抢光了',
  TEMPORARILY_OUT_OF_STOCK: '暂时无货',
  THE_PRODUCT_ALREADY_SOLD_OUT: '您来晚了，以下商品被抢光，为您从勾选中移除',
  CART_NO_ITEM: '购物车为空，快来添加宝贝吧',
  CART_NO_DOTD_OR_SPECIAL_SALE_EVENT_ITEM: '暂无镇店之宝、特卖汇商品',
  CART_NO_REDUCETHEPRICE_ITEM: '暂无商品降价',
  CART_NO_ALREADYSOLDOUT_ITEM: '暂无商品被抢光',
  PLEASE_ADD_DELIVERY_LOCATION: '请添加收货地',
  TOTAL_AMOUNT_OF_PRODUCTS: '商品总额',
  COLLECT_SUCCESSFULLY: '移入成功',
  COLLECT_FAILED: '移入失败',
  REMOVE_SUCCESSFULLY: '移出成功',
  REMOVE_FAILED: '移出失败',
  DELETE_SUCCESSFULLY: '删除成功',
  INELIGIBLE_PRODUCT_CLEAR_SUCCESSFUL: '件失效商品清理成功',
  NO_SPACE_TO_CLEAR: '没有空间可以清理',
  GO_TO_CART: '前往购物车',
  ONE_CLICK_CLEAR: '一键清理',
  SHOPPING_CART_FULL_PROMPT: '购物车已满，请清理空间后再加车',
  ALREADY_AUTOMATIC_PURCHASE_RESTRICTION: '已自动限购',
  CART_EXCEEDED: '价格有误，请删减商品重新计算',
  NOT_SELECT_PRODUCT: '您还没有选择商品',
  PLEASE_FILL_IN_THE_ADDRESS_FIRSTLY: '请先填写收货地址，再查看明细'
};
